import { PaginationMetaDTO } from '../dto/PaginatedResponse.dto';
import { PaginationMetaModel } from '../model/Pagination.model';

export class PaginationUtil {
  public static mapToViewModel(
    dto: PaginationMetaDTO,
    orderKey?: string,
  ): PaginationMetaModel {
    return {
      current: dto.current,
      pages: dto.pages,
      total: dto.total,
      orderKey: orderKey,
    };
  }

  public static getNumberOfPages(
    rowCount: number,
    rowsPerPage: number,
  ): number {
    return Math.ceil(rowCount / rowsPerPage);
  }
}
